import { render, staticRenderFns } from "./Characteristics.vue?vue&type=template&id=135e1e0a&"
import script from "./Characteristics.vue?vue&type=script&lang=js&"
export * from "./Characteristics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports